export default "__VITE_ASSET__cb717ad0__"